import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService, SharedModule } from 'primeng/api';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { Textarea } from 'primeng/textarea';
import Sample from '../../../../../../types/sample/Sample';
import { SampleService } from '../../../../services/sample.service';

@Component({
    selector: 'app-toggle-on-hold-dialog',
    imports: [
        Dialog,
        FormsModule,
        SharedModule,
        Button,
        IftaLabelModule,
        Textarea
    ],
    templateUrl: './toggle-on-hold-dialog.component.html',
    styleUrl: './toggle-on-hold-dialog.component.scss'
})
export class ToggleOnHoldDialogComponent {

    @Input() sample: Sample | null = null;
    @Input() visible: boolean = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() toggled = new EventEmitter<void>();

    comment: string = '';
    loading: boolean = false;

    constructor(
        private sampleService: SampleService,
        private messageService: MessageService
    ) {
    }

    get header(): string {
        return this.sample?.onHold ? 'Discard on hold state' : 'Toggle On Hold';
    }

    get message(): string {
        return this.sample?.onHold
            ? 'Are you sure you want to discard the on hold status of this sample?'
            : 'Are you sure you want to toggle the ON HOLD status of this sample?';
    }

    toggle(): void {
        this.loading = true;
        this.sampleService.toggleOnHold(this.sample?.id!, this.comment).then(() => {
            this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: this.sample?.onHold
                    ? 'On hold status discarded successfully'
                    : 'On hold status toggled successfully',
                life: 3000,
            });
            this.visibleChange.emit(false);
            this.toggled.emit();
        }).catch((error: any) => {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.message,
                life: 3000,
            });
        }).finally(() => {
            this.loading = false;
        });
    }

    cancel(): void {
        this.visibleChange.emit(false);
    }
}
